import { render, staticRenderFns } from "./Fixture.vue?vue&type=template&id=8840f1aa&"
import script from "./Fixture.vue?vue&type=script&lang=js&"
export * from "./Fixture.vue?vue&type=script&lang=js&"
import style0 from "./Fixture.vue?vue&type=style&index=0&id=8840f1aa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports